<template>
    <targeting-router-link :to="routeTo" data-cy="account-number">
        <slot/>
    </targeting-router-link>
</template>

<script setup lang="ts">
import { TargetingRouterLink } from '@tritt/multipanel'
import {GENERAL_LEDGER} from '@/genleg'
import {computed} from 'vue'
import {PanelContentRequest} from '@tritt/multipanel'

const props = defineProps({
    accountNo: {required: true, type: String},
})

const routeTo = computed<PanelContentRequest>(() => ({
    ...GENERAL_LEDGER,
    queryValues: {accountNo: props.accountNo}
}))

</script>

<style scoped>

</style>